import { EMPLOYEE_MASTER } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const getEmployeeList = () => ({
  url: `${EMPLOYEE_MASTER}?cb=${Date.now()}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const createEmployee = (payload) => ({
  url: `${EMPLOYEE_MASTER}/create`, // 🌟 FIX: Point to dedicated create route
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.LANDING_MS,
});

export const getEmployeeById = (empNo) => ({
  url: `${EMPLOYEE_MASTER}/${empNo}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const updateEmployee = (empNo, payload) => ({
  url: `${EMPLOYEE_MASTER}/${empNo}`,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload,
  service: serviceName.LANDING_MS,
});

export const deleteEmployee = (empNo) => ({
  url: `${EMPLOYEE_MASTER}/${empNo}`,
  method: 'delete',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getEmployeeChangeHistory = () => ({
  url: `${EMPLOYEE_MASTER}/history`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getVerticals = () => ({
  url: `${EMPLOYEE_MASTER}/filters/verticals`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getEmployeeType = () => ({
  url: `${EMPLOYEE_MASTER}/filters/emp-types`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getRegions = () => ({
  url: `${EMPLOYEE_MASTER}/filters/regions`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getCountries = () => ({
  url: `${EMPLOYEE_MASTER}/filters/countries`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getJoiningTypes = () => ({
  url: `${EMPLOYEE_MASTER}/filters/joining-types`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getDepartments = () => ({
  url: `${EMPLOYEE_MASTER}/filters/departments`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getDesignations = () => ({
  url: `${EMPLOYEE_MASTER}/filters/designations`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getExperienceCategories = () => ({
  url: `${EMPLOYEE_MASTER}/filters/experience-categories`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getLocations = () => ({
  url: `${EMPLOYEE_MASTER}/filters/locations`,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});

export const getActiveAllocations = (empNo, date) => ({
  url: `${EMPLOYEE_MASTER}/${empNo}/active-allocations?date=${date}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.LANDING_MS,
});
